import { FC, useEffect } from 'react'
import { styled } from '../../../lib/stitches'
import { AnnouncementHeader } from '../../core/AnnouncementHeader'
import { Navbar } from '../../platform/dashboard/Navbar'
import { News } from '../../platform/dashboard/news'
import Ticker from '../../platform/dashboard/Ticker'
import Explore from '../../platform/new-explore/Explore'
import Footer from './Footer'

const DashboardContainer = styled('div', {
  background: '$background__primary'
})

const Dashboard: FC = () => {
  useEffect(() => {
    document.title = 'Arpeggi Dashboard'
  }, [])

  return (
    <DashboardContainer>
      <AnnouncementHeader />
      <Ticker variant="small" />
      <Navbar />
      <News />
      <Explore />
      <Footer />
    </DashboardContainer>
  )
}
export default Dashboard
